import { cn } from '@/utils/cn';
import NoMessageIcon from '../icons/no-message-icon';
import NoDataIcon from '../icons/no-data-icon';

interface IEmptySectionProps {
  iconClassName?: string;
  containerClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  type: 'message' | 'data';
  title: string;
  description?: string;
}
const EmptySection = ({
  iconClassName,
  containerClassName,
  titleClassName,
  descriptionClassName,
  type,
  title,
  description,
}: IEmptySectionProps) => {
  const Icon = type === 'message' ? NoMessageIcon : NoDataIcon;

  return (
    <div className={cn('flex items-center justify-center h-full flex-col', containerClassName)}>
      <Icon className={cn('w-[150px] h-[100px] flex-shrink-0 text-[#6485A7]', iconClassName)} />
      <div className="flex flex-col items-center justify-center gap-[4px]">
        <span className={cn('text-[14px] font-[600] text-[#25151E]', titleClassName)}>{title}</span>
        <span className={cn('text-[12px] font-[400] text-[#9D9D9C]', descriptionClassName)}>{description}</span>
      </div>
    </div>
  );
};

export default EmptySection;
